<template>
  <div class="select-city-container" v-show="cityList && cityList.length > 0">
    <template>
      <div class="pop-container-content">
        <h2>{{gettext('选择城市')}}</h2>
        <p class="location">{{gettext('当前定位城市：')}}{{locationCity}}</p>
        <div v-for="(city, index) in cityList" class="city-list">
          <p :class="{'item':true, 'selected': currentSelected === city.cityName}" @click="handleSelected(city)">{{city.cityName}}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    locationCity: {
      type: String,
      default: ''
    },
    cityList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentSelected: ''
    }
  },
  watch: {
    cityList (nval) {
      const cityInfo = nval.find((item) => {
        return item.isSelected === true
      })
      this.currentSelected = cityInfo ? cityInfo.cityName : ''
    }
  },
  methods: {
    handleSelected (city) {
      this.currentSelected = city.cityName
      this.currentCityObj = city
      this.$emit('selected', city)
    },
    handleConfirm () {
      this.$emit('select', this.currentCityObj)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
$conversion = 0.5859375px
.rich-floating 
  .bottom-wrap-content-box
    z-index 9999
.select-city-container
  margin-top 40px
  display flex
  justify-content center
  height 100%
  width 100%
  z-index 9
  overflow-y scroll
  .pop-container-content
    z-index 2
    padding 80px 20px 0
    width 100%
    h2
      height 56px
      font-family "Aspira Demi"
      font-size 56px
      color #000
      line-height 56px
      font-style normal
      font-weight 500
    .title
      font-size 56px
      color #333
      line-height 56px
    .location
      margin-bottom 30px
      padding 24px 0 0
      height 36px
      font-family "Aspira Regular"
      font-size 32px
      color #666
      text-align left
      line-height 36px
      font-weight 400
    .city-list
      border-bottom 1px #e5e5e5 solid
      padding 48px 0 50px
      .item
        position relative
        padding 0
        height 40px
        line-height 36px
        font-family "Aspira Demi"
        font-size 36px
        color #000
        font-weight 500
        &:after
          position absolute
          right 0
          top 50%
          margin-top -15px
          content ""
          display block
          width 40px
          height 40px
        &.selected
          &::after
            position absolute
            right 0
            top 50%
            margin-top -15px
            content ""
            display block
            width 40px
            height 40px
[data-theme='didi']
  .select-city-container
    .pop-container-content
      .city-list
        .item
          &:after {
            background url("~@/assets/images/xtd/select_false.png") no-repeat
            background-size: 100% 100%
          }
          &.selected
            &::after
              background url("~@/assets/images/xtd/select_true.png") no-repeat
              background-size: 100% 100%

[data-theme='99']
  .select-city-container
    .pop-container-content
      .city-list
        .item
          &:after {
            background url("~@/assets/images/xtd/select_false.png") no-repeat
            background-size: 100% 100%
          }
          &.selected
            &::after
              background url("~@/assets/images/xtd/select_true.png") no-repeat
              background-size: 100% 100%

</style>

